import { updateImage } from 'actions/MediaActions';
import { ImageView } from 'components/mediaLibrary/images/ImageView';
import { Content } from '@visikon/core-models';
import { connect, MapDispatchToProps } from 'react-redux';
import { IState } from 'reducers/reducers';
import { ObjectId } from '@visikon/core-models/base';

interface IPropsFromState {
  // eslint-disable-next-line react/no-unused-prop-types,react/require-default-props
  token?: string;
  languageFromState: Content.LanguageCode;
}
interface IPropsFromDispatch {
  addTag: (tag: Content.Tag) => void;
  removeTag: (tag: Content.Tag) => void;
}
/* eslint-disable react/no-unused-prop-types,react/require-default-props */
interface IOwnProps {
  image: Content.Image;
  language?: Content.LanguageCode;
  mediaVariation?: ObjectId;
  onClick?: () => void;
  readOnly?: boolean;
  className?: string;
}

function CImageContainer(props: IPropsFromState & IPropsFromDispatch & IOwnProps) {
  const { image, onClick, addTag, removeTag, languageFromState, readOnly, className } = props;

  return (
    <ImageView
      onClick={onClick}
      onTagAdded={addTag}
      onTagRemoved={removeTag}
      readOnly={readOnly}
      image={image}
      className={className}
      language={props.language || languageFromState}
    />
  );
}

const mapStateToProps: (state: IState) => IPropsFromState = (state) => ({
  languageFromState: state.language.activeLanguage,
  mediaVariationFromState: state.language.activeMediaVariation,
});

const mapDispatchToProps: MapDispatchToProps<IPropsFromDispatch, IOwnProps> = (dispatch, ownProps) => ({
  addTag: (tag: Content.Tag) => {
    if (!tag) {
      return;
    }
    const { image } = ownProps;
    const tagIdx = image.tags.indexOf(tag);
    if (tagIdx === -1) {
      image.tags.push(tag);
      dispatch(updateImage(image));
    }
  },
  removeTag: (tag: Content.Tag) => {
    if (!tag) {
      return;
    }
    const { image } = ownProps;
    const tagIdx = image.tags.indexOf(tag);
    if (tagIdx >= 0) {
      image.tags.splice(image.tags.indexOf(tag), 1);
      dispatch(updateImage(image));
    }
  },
});

export const ImageContainer = connect(mapStateToProps, mapDispatchToProps)(CImageContainer);
